export default class Endpoint {
  constructor(api) {
    this.api = api
  }

  request(...args) {
    return this.api.request(...args)
  }
}
